export default "__VITE_ASSET__kqP1RSlw__"